import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { getUnreadNotifCount } from "../lib/services";

export default function NotificationBell({ className = "" }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let mounted = true;
    const poll = async () => {
      try {
        const r = await getUnreadNotifCount();
        if (mounted) setCount(r.count || 0);
      } catch (err) {
        console.warn("unread count fetch failed:", err);
      }
    };
    poll();
    const id = setInterval(poll, 45000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  return (
    <Link
      to="/notifications"
      data-testid="notif-bell"
      className={`relative inline-flex items-center justify-center ${className}`}
      aria-label={count ? `${count} unread notifications` : "notifications"}
    >
      <Bell className="w-4 h-4" strokeWidth={2} />
      {count > 0 && (
        <span
          data-testid="notif-unread-count"
          className="absolute -top-1 -right-1 min-w-[14px] h-[14px] bg-acid text-black text-[9px] font-mono leading-none flex items-center justify-center px-1 tabular-nums"
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
}
